import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Profile from './components/Profile';
import Work from './components/Work';
import Schooling from './components/Schooling';
import Contact from './components/Contact';

function App() {
  return (
    <div className="page">
      <Header />
      <Profile />
      <Work/>
      <Schooling/>
      <Contact/>
      <Footer />
    </div>
  );
}

export default App;
